import MaskingTransformation from "./maskingTransformation";
import FieldRemoverTransformation from "./fieldRemoverTransformation";
import FieldRenamerTransformation from "./fieldRenamerTransformation";
import FieldTypeModifierTransformation from "./fieldTypeModifierTransformation";
import FieldFilterTransformation from "./fieldFilterTransformation";
import FieldSplitterTransformation from "./fieldSplitterTransformation";
import FieldAdderTransformation from "./fieldAdderTransformation";
import JsonReaderTransformation from "./JsonReaderTransformation";
import TypedEventToWaDbEventTransformation from "./typedEventToWaDbEventTransformation";
import WaeMetaFilterTransformation from "./waeMetaFilterTransformation";
import WaeDbTableFilterTransformation from "./waeDbTableFilterTransformation";
import WaeOperatorFilterTransformation from "./waeOperatorFilterTransformation";
import WaeAddUserDataTransformation from "./waeAddUserDataTransformation";
import WaeToTypedEventTransformation from "./waeToTypedEventTransformation";
import FieldEnricherTransformation from "./fieldEnricherTransformation";
import WaeToDwStageTransformation from "./waeToDwStageTransformation";
import ShieldTransformation from "./shieldTransformation";
import WaeDataModifierTransformation from "./waeDataModifierTransformation";
import ForeseerTransformation from "./foreseerTransformation";
import EuclidTransformation from "./euclidTransformation";
import componentService from "../../../../../../core/services/componentService/component-service";

var Provider = {};

Provider.getTransformationByName = function(componentName) {
    if (componentName === componentService.getHumanReadableName("TransformationMasking")) {
        return MaskingTransformation;
    } else if (componentName === componentService.getHumanReadableName("TransformationFieldRemover")) {
        return FieldRemoverTransformation;
    } else if (componentName === componentService.getHumanReadableName("TransformationFieldRenamer")) {
        return FieldRenamerTransformation;
    } else if (componentName === componentService.getHumanReadableName("TransformationFieldTypeModifier")) {
        return FieldTypeModifierTransformation;
    } else if (componentName === componentService.getHumanReadableName("TransformationFieldFilter")) {
        return FieldFilterTransformation;
    } else if (componentName === componentService.getHumanReadableName("TransformationFieldSplitter")) {
        return FieldSplitterTransformation;
    } else if (componentName === componentService.getHumanReadableName("TransformationFieldEnricher")) {
        return FieldEnricherTransformation;
    } else if (componentName === componentService.getHumanReadableName("TransformationJsonReader")) {
        return JsonReaderTransformation;
    } else if (componentName === componentService.getHumanReadableName("TransformationTypedEventToWaDbEvent")) {
        return TypedEventToWaDbEventTransformation;
    } else if (componentName === componentService.getHumanReadableName("TransformationFieldAdder")) {
        return FieldAdderTransformation;
    } else if (componentName === componentService.getHumanReadableName("TransformationWaeMetaFilter")) {
        return WaeMetaFilterTransformation;
    } else if (componentName === componentService.getHumanReadableName("TransformationWaeDbTableFilter")) {
        return WaeDbTableFilterTransformation;
    } else if (componentName === componentService.getHumanReadableName("TransformationWaeOperatorFilter")) {
        return WaeOperatorFilterTransformation;
    } else if (componentName === componentService.getHumanReadableName("TransformationWaeAddUserData")) {
        return WaeAddUserDataTransformation;
    } else if (componentName === componentService.getHumanReadableName("TransformationWaeToTypedEvent")) {
        return WaeToTypedEventTransformation;
    } else if (componentName === componentService.getHumanReadableName("TransformationWaeToDwStage")) {
        return WaeToDwStageTransformation;
    } else if (componentName === componentService.getHumanReadableName("TransformationShield")) {
        return ShieldTransformation;
    } else if (componentName === componentService.getHumanReadableName("TransformationWaeDataModifier")) {
        return WaeDataModifierTransformation;
    }
    else if (componentName === componentService.getHumanReadableName("Foreseer")) {
            // Foreseer uses its own transformation to invoke the forecast function
            return ForeseerTransformation;
        } else if (componentName === componentService.getHumanReadableName("Euclid") ) {
            // Euclid uses its own transformation to invoke the generateEmbeddings function
            return EuclidTransformation;
        }


    return null;
};

export default Provider;
